import { TRouteConfig } from 'app/types'
import { useAppRedirect } from 'app/use_app_redirect'
import { useLocationSetup } from 'hooks/use_location_setup'
import { useMonitoringData } from 'hooks/use_monitoring_data'
import { Outlet, ScrollRestoration } from 'react-router-dom'

export const AppLayout = ({ routeConfigs }: { routeConfigs: TRouteConfig[] }) => {
  useAppRedirect(routeConfigs)
  useLocationSetup()
  useMonitoringData()

  return (
    <>
      <ScrollRestoration />
      <Outlet />
    </>
  )
}
